import React from "react";
import { useNavigate } from "react-router-dom"; // Hook for programmatic navigation
import { motion } from "framer-motion"; // For hover/tap animations
import "./ReusableCard.css";

function ReusableCard({ title, image, link }) {
  const navigate = useNavigate();

  // Function to handle click events
  // If a 'link' prop is provided, navigate to that route
  const handleClick = () => {
    if (link) navigate(link);
  };

  // Function to handle keyboard events for accessibility
  // Activates card when Enter or Space is pressed
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault(); // Prevent page scrolling for Space
      handleClick();
    }
  };

  return (
    <motion.div
      className="about-card clickable" // Card styling & hover cursor
      onClick={handleClick}             // Mouse click interaction
      onKeyDown={handleKeyDown}         // Keyboard interaction
      role="link"                       // ARIA role for screen readers
      tabIndex="0"                      // Makes the card focusable via keyboard
      aria-label={`Learn more about ${title}`} // Descriptive label for screen readers
      whileHover={{ scale: 1.05 }}      // Framer Motion hover effect
      whileTap={{ scale: 0.95 }}        // Framer Motion tap effect
      variants={{
        hidden: { opacity: 0, y: 30 },  // Initial animation state
        visible: { opacity: 1, y: 0 },  // Visible animation state
      }}
    >
      {/* Optional image for the card */}
      {image && <img src={image} alt={title} className="about-card-image" />}

      {/* Card title */}
      <div className="about-card-text">
        <h2>{title}</h2>
      </div>
    </motion.div>
  );
}

export default ReusableCard;
